import withHeaderAndFooter from "./with-header-and-footer-hoc";

export default withHeaderAndFooter;